module.exports = __webpack_public_path__ + "static/media/icon-national.2a81c915.svg";